import { defineStore } from "pinia";
import { geolocationMixin } from "~/mixins/geolocationMixin.js";

const getLocationAndCall = geolocationMixin.methods.getLocationAndCall;
const { trackEvent } = useEventTracker("countly");

export const useBelajarWajibStore = defineStore({
  id: "belajarWajib",
  state: () => ({
    loadingLogin: false,
    loadingMfaVerification: false,
    dataPegawai: {},
    loadingGetDetailPegawai: false,
    errorGetDetailPegawai: false,
    courseList: [],
    loadingGetCourses: false,
    errorGetCourses: false,
    materiList: [],
    loadingGetMateriByType: false,
    errorGetMateriByType: false,
    progressMateriList: [],
    loadingGetProgressMateri: false,
    errorGetProgressMateri: false,
    totalTrophy: 0,
    loadingGetTotalTrophy: false,
    errorGetTotalTrophy: false,
    urlPdfBahan: "",
    loadingGetViewfilebahan: false,
    errorGetViewfilebahan: false,
    essay: {
      list: [],
      totalElements: 0,
      totalPages: 0,
      size: 10,
    },
    loadingEssayByTypeId: false,
    errorEssayByTypeId: false,
    essayData: {},
    loadingGetEssay: false,
    errorGetEssay: false,
    loadingDownloadEssay: false,
    journalList: [],
    loadingGetJournalByNip: false,
    errorGetJournalByNip: false,
    evaluationList: [],
    loadingGetEvalByCourseId: false,
    errorGetEvalByCourseId: false,
    questionsList: [],
    loadingGetQuestion: false,
    errorGetQuestion: false,
    angkatan: {},
    loadingGetAngkatanById: false,
    errorGetAngkatanById: false,
    sertifikat: {},
    loadingGetByAngkatanAndUser: false,
    errorGetByAngkatanAndUser: false,
    profile: {},
    loadingGetProfileUser: false,
    errorGetProfileUser: false,
    courseMe: {},
    loadingGetCourseByAngkatan: false,
    errorGetCourseByAngkatan: false,
    microList: [],
    loadingGetMateriMicro: false,
    errorGetMateriMicro: false,
    multipleChoiceNotStarted: {
      status: false,
      message: "",
    },
    isRoleAsn: false,
    isforgotPasswordSuccess: false,
    pdfBlob: null,
    loadingGetUrlBahan: false,
    toggleList: [],
    toggleFeature: {
      message: "",
      name: "",
      status: false,
      startTime: null,
      endTime: null,
    },
    toggleGeneral: {},
    toggleFeatureError: false,
  }),
  getters: {
    isAuthorized() {
      const lsToken = localStorage.getItem("tokenBelajarWajib");
      return !!lsToken && lsToken !== "undefined";
    },
    token() {
      const lsToken = localStorage.getItem("tokenBelajarWajib");
      return lsToken && lsToken !== "undefined" ? lsToken : null;
    },
    filteredCourseData(state) {
      return (
        state.courseList.find(
          (key) =>
            key.angkatan.masterTypes.namaType ===
            localStorage.getItem("courseType"),
        ) || {}
      );
    },
    isMaintenanceMode() {
      const start = useBelajarWajibStore().toggleFeature.startTime
        ? new Date(
            useBelajarWajibStore().toggleFeature.startTime.replace("  ", " "),
          )
        : null;
      const end = new Date(useBelajarWajibStore().toggleFeature.endTime);
      const now = new Date();
      const status = useBelajarWajibStore().toggleFeature.status;
      return status && now >= start && now <= end;
    },
  },
  actions: {
    getBelajarWajibBaseUrl() {
      const config = useNuxtApp().$config;
      const configuredBase = (config?.public?.apiBelajarWajib || "").trim();
      if (configuredBase) {
        return configuredBase.replace(/\/+$/, "");
      }

      if (typeof window !== "undefined") {
        const host = window.location.hostname;
        if (host.includes("dev-sibangkom") || host.includes("stg")) {
          return "https://dev-sibangkom-mandiri.lan.go.id";
        }
      }

      return "https://sibangkom-mandiri.lan.go.id";
    },
    async loginBelajarWajib(payload) {
      this.loadingLogin = true;
      const baseUrl = this.getBelajarWajibBaseUrl();
      let stateTracker = "";

      try {
        const response = await $fetch.raw(`${baseUrl}/sibangkom-auth/login`, {
          method: "POST",
          body: payload,
        });
        const data = response?._data || {};
        // Check if MFA is required or device registration is needed
        if (payload.via === "mfa") {
          if (data.mfaEnabled) {
            // If MFA is required, return the state but don't set tokens yet
            return { mfaEnabled: true };
          } else if (data.otpAuthUrl) {
            // If user needs to set up MFA
            return { otpAuthUrl: data.otpAuthUrl };
          }
        }
        // Normal flow - set tokens and navigate
        useBelajarWajibStore().setTokens(data.data);
        useUserStore().$patch({
          snackStatus: "green",
          snackbar: true,
          messageSnack: response?._data?.message,
        });
        stateTracker = "success";
        // Check for redirect after login
        return setTimeout(() => {
          const redirectPath = localStorage.getItem("redirectAfterLogin");
          if (redirectPath) {
            localStorage.removeItem("redirectAfterLogin");
            return navigateTo(redirectPath, { external: true });
          }
          navigateTo("/pembelajaran-wajib", { external: true });
        }, 800);
      } catch (error) {
        stateTracker = "failed";
        const d = error?.response?._data;
        useUserStore().$patch({
          snackStatus: "error",
          snackbar: true,
          messageSnack: d?.error || d?.message || "Login gagal!",
        });
        useBelajarWajibStore().clearTokens();
      } finally {
        getLocationAndCall((lat, long) => {
          trackEvent({
            key: "login",
            count: 1,
            segmentation: {
              location: `${lat}, ${long}`,
              state: stateTracker,
              triggerLocation: "btn_masuk",
              page: "login",
              nip: payload?.username || "unknown",
            },
          });
        });
        this.loadingLogin = false;
      }
    },
    async handleMfaVerification(payload) {
      this.loadingMfaVerification = true;
      const baseUrl = this.getBelajarWajibBaseUrl();
      const isDeviceRegistration = !!payload.deviceName;
      try {
        const params = new URLSearchParams({
          code: payload.mfaCode,
          username: payload.username,
          deviceName: payload.deviceName || "",
        });
        const response = await $fetch.raw(
          `${baseUrl}/sibangkom-auth/users/verification/mfa?${params}`,
          {
            method: "POST",
            body: null,
          },
        );
        // Handle token setting only for login verification, not for device registration
        if (!isDeviceRegistration) {
          const data = response?._data?.data || {};
          useBelajarWajibStore().setTokens(data);
        }
        useUserStore().$patch({
          snackStatus: isDeviceRegistration ? "success" : "green",
          snackbar: true,
          messageSnack: isDeviceRegistration
            ? "Perangkat berhasil didaftarkan, silahkan login kembali."
            : "Verifikasi berhasil. Anda telah masuk.",
        });
        // Navigate to home only for login verification
        if (!isDeviceRegistration) {
          // Check for redirect after login
          const redirectPath = localStorage.getItem("redirectAfterLogin");
          if (redirectPath) {
            localStorage.removeItem("redirectAfterLogin");
            return navigateTo(redirectPath, { external: true });
          }
          return navigateTo("/pembelajaran-wajib", { external: true });
        }
        return true;
      } catch (error) {
        useUserStore().$patch({
          snackStatus: "error",
          snackbar: true,
          messageSnack:
            error?.response?._data || "Kode verifikasi tidak valid.",
        });
        // Clear tokens only for device registration failure
        if (isDeviceRegistration) {
          useBelajarWajibStore().clearTokens();
        }
        return false;
      } finally {
        this.loadingMfaVerification = false;
      }
    },
    async forgotPassword(payload) {
      this.loadingLogin = true;
      const baseUrl = this.getBelajarWajibBaseUrl();
      try {
        const response = await $fetch.raw(
          `${baseUrl}/sibangkom-auth/users/forgot-password`,
          {
            method: "POST",
            body: payload,
          },
        );
        useAuthStore().$patch({
          snackStatus: "positive",
          snackbar: true,
          messageSnack: response?._data?.message,
          isRevamp: true,
        });
        useBelajarWajibStore().$patch((state) => {
          state.isforgotPasswordSuccess = true;
        });
      } catch (error) {
        useAuthStore().$patch({
          snackStatus: "destructive",
          snackbar: true,
          messageSnack: error?.response?._data?.message || "Terjadi kesalahan.",
          isRevamp: true,
        });
        useBelajarWajibStore().$patch((state) => {
          state.isforgotPasswordSuccess = false;
        });
      } finally {
        this.loadingLogin = false;
      }
    },
    async resetPassword(payload) {
      this.loadingLogin = true;
      const baseUrl = this.getBelajarWajibBaseUrl();
      try {
        const response = await $fetch.raw(
          `${baseUrl}/sibangkom-auth/users/reset-password`,
          {
            method: "PATCH",
            body: payload,
          },
        );
        useAuthStore().$patch({
          snackStatus: "positive",
          snackbar: true,
          messageSnack: response?._data?.message,
          isRevamp: true,
        });
        setTimeout(() => {
          navigateTo({ path: "/login" });
        }, 1500);
      } catch (error) {
        useAuthStore().$patch({
          snackStatus: "destructive",
          snackbar: true,
          messageSnack: error?.response?._data?.message || "Terjadi kesalahan.",
          isRevamp: true,
        });
      } finally {
        this.loadingLogin = false;
      }
    },
    async verifyEmail(payload) {
      this.loadingLogin = true;
      const baseUrl = this.getBelajarWajibBaseUrl();
      try {
        const response = await $fetch.raw(
          `${baseUrl}/sibangkom-auth/users/verification/verify`,
          {
            method: "POST",
            body: payload,
          },
        );
        useAuthStore().$patch({
          snackStatus: "positive",
          snackbar: true,
          messageSnack: response?._data?.message,
          isRevamp: true,
        });
        setTimeout(() => {
          navigateTo({ path: "/login" });
        }, 1500);
      } catch (error) {
        useAuthStore().$patch({
          snackStatus: "destructive",
          snackbar: true,
          messageSnack: error?.response?._data?.message || "Terjadi kesalahan.",
          isRevamp: true,
        });
      } finally {
        this.loadingLogin = false;
      }
    },
    async refreshToken(token) {
      const refreshToken =
        token || localStorage.getItem("refreshTokenBelajarWajib");
      const isFromRevamp = /revamp/.test(useRoute().path);

      if (!refreshToken) {
        navigateTo({ path: `${isFromRevamp ? "revamp" : ""}/login` });
      }
      const payload = {
        refreshToken: refreshToken,
      };
      const baseUrl = this.getBelajarWajibBaseUrl();
      try {
        const response = await $fetch.raw(`${baseUrl}/auth/token/refresh`, {
          method: "POST",
          body: payload,
        });
        const data = response?._data?.data || {};
        useBelajarWajibStore().setTokens(data);
        useBelajarWajibStore().$patch((state) => {
          state.token = localStorage.getItem("tokenBelajarWajib");
        });
      } catch (error) {
        useAuthStore().$patch({
          snackStatus: "destructive",
          snackbar: true,
          messageSnack:
            error?.response?._data?.message || "Refresh token gagal.",
          isRevamp: true,
        });
        navigateTo({ path: `${isFromRevamp ? "revamp" : ""}/login` });
        useBelajarWajibStore().clearTokens();
      }
    },
    setTokens(data) {
      const accessToken = data.jwttoken;
      const refreshToken = data.refreshToken;
      localStorage.setItem("tokenBelajarWajib", accessToken);
      localStorage.setItem("refreshTokenBelajarWajib", refreshToken);
    },
    clearTokens() {
      localStorage.removeItem("tokenBelajarWajib");
      localStorage.removeItem("refreshTokenBelajarWajib");
      localStorage.removeItem("courseType");
      localStorage.removeItem("courseList");
      localStorage.removeItem("dataPegawai");
      localStorage.removeItem("profile");
    },
    // async clearTokens() {
    //   const event = useRequestEvent();
    //   try {
    //     await fetchBelajarWajib(
    //       event,
    //       "/sibangkom-auth/api/oauth/logout",
    //       "POST"
    //     );
    //   } catch (error) {
    //   } finally {
    //     localStorage.removeItem("tokenBelajarWajib");
    //     localStorage.removeItem("refreshTokenBelajarWajib");
    //     localStorage.removeItem("courseType");
    //     localStorage.removeItem("courseList");
    //     localStorage.removeItem("dataPegawai");
    //     localStorage.removeItem("profile");
    //   }
    // },
    async getDetailPegawai() {
      this.loadingGetDetailPegawai = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          "/auth/pegawai/getDetail",
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.dataPegawai = response || {};
          state.isRoleAsn = ["PNS", "CPNS", "PPPK", "ASN", "NON-ASN"].includes(
            response.statusPegawai,
          );
        });
        localStorage.setItem("dataPegawai", JSON.stringify(response || {}));
        this.errorGetDetailPegawai = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetDetailPegawai = true;
        }
      } finally {
        this.loadingGetDetailPegawai = false;
      }
      if (!useBelajarWajibStore().isRoleAsn) {
        useBelajarWajibStore().clearTokens();
        return navigateTo({ path: "/pembelajaran-wajib/login" });
      }
    },
    async getCoursesByTokenFromLocalStorage() {
      const currentCourseList = JSON.parse(localStorage.getItem("courseList"));
      useBelajarWajibStore().$patch((state) => {
        state.courseList = currentCourseList;
      });
    },
    async getCourses() {
      this.loadingGetCourses = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          "/mooc/api/getcoursebytoken",
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          const peserta = response?.peserta || {};
          state.courseList =
            Object.keys(peserta).length > 0 ? peserta.body : [];
        });
        /// simpan course id dari array pertama
        localStorage.setItem(
          "courseId",
          response?.peserta?.body[0]?.uuid || "",
        );
        /// simpan course list ke localStorage
        localStorage.setItem(
          "courseList",
          JSON.stringify(response?.peserta.body) || [],
        );
        this.errorGetCourses = false;
      } catch (error) {
        if (
          (error.response?.status === 401 &&
            error.response?._data === "Token is invalid or unauthorized") ||
          (error.response?.status === 401 &&
            error.response?._data === "Token is expired")
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetCourses = true;
        }
      } finally {
        this.loadingGetCourses = false;
      }
    },
    async getMateriByType(masterTypeId) {
      this.loadingGetMateriByType = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/mooc/api/materi/getmateribytype/${masterTypeId}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.materiList = response.length > 0 ? response : [];
        });
        this.errorGetMateriByType = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetMateriByType = true;
        }
      } finally {
        this.loadingGetMateriByType = false;
      }
    },
    async getProgressMateriByCourse() {
      this.loadingGetProgressMateri = true;
      const event = useRequestEvent();
      try {
        /// mendapatkan courseId dari localStorage
        /// courseId didapatkan dari api coursebytoken
        const courseId = localStorage.getItem("courseId");
        const response = await fetchBelajarWajib(
          event,
          `/mooc/api/progressmateri/getprogressmateribycourse/${courseId}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.progressMateriList = response || [];
        });
        this.errorGetProgressMateri = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetProgressMateri = true;
        }
      } finally {
        this.loadingGetProgressMateri = false;
      }
    },
    async getTotalTrophy() {
      this.loadingGetTotalTrophy = true;
      const event = useRequestEvent();
      try {
        /// mendapatkan courseId dari localStorage
        /// courseId didapatkan dari api coursebytoken
        const courseId = localStorage.getItem("courseId");
        const response = await fetchBelajarWajib(
          event,
          `/mooc/api/progressmateri/getTotalTrophy/${courseId}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.totalTrophy = response || 0;
        });
        this.errorGetTotalTrophy = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetTotalTrophy = true;
        }
      } finally {
        this.loadingGetTotalTrophy = false;
      }
    },
    async getViewfilebahan(filename) {
      this.loadingGetViewfilebahan = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/swajar-cache-reader/api/bahan/viewfilebahan${filename}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.urlPdfBahan = !!response ? URL.createObjectURL(response) : "";
        });
        this.errorGetViewfilebahan = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "red",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
          this.errorGetViewfilebahan = true;
        }
      } finally {
        this.loadingGetViewfilebahan = false;
      }
    },
    async getEssayByTypeId(masterTypeId, page = 0, size = 10) {
      this.loadingEssayByTypeId = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/mooc/api/topik/getByTypeId/${masterTypeId}/${page}/${size}/all`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.essay = {
            list: response.content,
            totalElements: response.totalElements,
            totalPages: response.totalPages,
            size: response.size,
          };
        });
        this.errorEssayByTypeId = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorEssayByTypeId = true;
        }
      } finally {
        this.loadingEssayByTypeId = false;
      }
    },
    async getEssayByCourseId(courseId) {
      this.loadingGetEssay = true;
      const event = useRequestEvent();
      try {
        const res = await fetchBelajarWajib(
          event,
          `/mooc/api/essai/essaiByCoursesId/${courseId}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.essayData = Object.keys(res).length > 0 ? res?.body || {} : {};
        });
        this.errorGetEssay = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetEssay = true;
        }
      } finally {
        this.loadingGetEssay = false;
      }
    },
    async downloadEssay(urlFilename, filename) {
      this.loadingDownloadEssay = true;
      const event = useRequestEvent();
      const formData = new FormData();
      formData.append("filename", urlFilename + filename);
      try {
        const res = await fetchBelajarWajib(
          event,
          "/mooc/api/essai/essai",
          "POST",
          formData,
        );
        useUserStore().$patch({
          snackStatus: "green",
          snackbar: true,
          messageSnack: `Sukses mengunduh file ${filename}.`,
        });
        const url = URL.createObjectURL(res);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (error) {
        useUserStore().$patch({
          snackStatus: "red",
          snackbar: true,
          messageSnack:
            error?.response?._data?.message || "Gagal mengunduh file esai.",
        });
      } finally {
        this.loadingDownloadEssay = false;
      }
    },
    async getJournalByNip() {
      this.loadingGetJournalByNip = true;
      const event = useRequestEvent();
      const dataPegawai = useBelajarWajibStore().dataPegawai || {};
      const nip = dataPegawai.nip || "";
      try {
        const res = await fetchBelajarWajib(
          event,
          `/mooc/api/jurnal/jurnalbynip/${nip}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.journalList = res.length > 0 ? res : [];
        });
        this.errorGetJournalByNip = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetJournalByNip = true;
        }
      } finally {
        this.loadingGetJournalByNip = false;
      }
    },
    async getEvaluationByCourseId(courseId) {
      this.loadingGetEvalByCourseId = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/mooc/api/evaluation/getByCourse/${courseId}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          const data = Object.keys(response).length > 0 ? response : {};
          state.evaluationList = data || [];
        });
        this.errorGetEvalByCourseId = false;
      } catch (error) {
        if (error.response?.status === 409) {
          useBelajarWajibStore().$patch((state) => {
            state.multipleChoiceNotStarted = {
              status: true,
              message: error.response?._data.message || "",
            };
          });
        }
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetEvalByCourseId = true;
        }
      } finally {
        this.loadingGetEvalByCourseId = false;
      }
    },
    async getQuestionByPaketAndType(masterPaketId, masterTypeId) {
      this.loadingGetQuestion = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/${useBelajarWajibReaderStore().isCPNS ? "cpns-orientation" : "mooc"}/api/question/getQuestionByPaketAndType/${masterPaketId}/${masterTypeId}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.questionsList = response.length > 0 ? response : [];
        });
        this.errorGetQuestion = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetQuestion = true;
        }
      } finally {
        this.loadingGetQuestion = false;
      }
    },
    async getQuestionByIdCourse(idCourse) {
      this.loadingGetQuestion = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/${useBelajarWajibReaderStore().isCPNS ? "cpns-orientation" : "swajar-cache-reader"}/api/question/v2/getQuestionByIdCourse${useSwajarKurikulumStore().materiType === "k2" ? "KurikulumDua" : ""}/${idCourse}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.questionsList = response.length > 0 ? response : [];
        });
        this.errorGetQuestion = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetQuestion = true;
        }
      } finally {
        this.loadingGetQuestion = false;
      }
    },
    async getAngkatanById(angkatanId) {
      this.loadingGetAngkatanById = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/${useBelajarWajibReaderStore().isCPNS ? "cpns-orientation" : "mooc"}/api/angkatan/getById/${angkatanId}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.angkatan = response || {};
        });
        this.errorGetAngkatanById = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetAngkatanById = true;
        }
      } finally {
        this.loadingGetAngkatanById = false;
      }
    },
    async getByAngkatanAndUser(angkatanId) {
      this.loadingGetByAngkatanAndUser = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/dashboard-profile/api/sertifikat/${useSwajarKurikulumStore().materiType === "k2" ? "kdua/" : ""}getByAngkatanAndUser/${angkatanId}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.sertifikat = response || {};
        });
        this.errorGetByAngkatanAndUser = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetByAngkatanAndUser = true;
        }
      } finally {
        this.loadingGetByAngkatanAndUser = false;
      }
    },
    async getProfileUser() {
      this.loadingGetProfileUser = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          "/dashboard-profile/api/profile/getbyuser",
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.profile = response || {};
        });
        localStorage.setItem("profile", JSON.stringify(response || {}));
        this.errorGetProfileUser = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetProfileUser = true;
        }
      } finally {
        this.loadingGetProfileUser = false;
      }
    },
    async getCourseByAngkatan(angkatanId) {
      this.loadingGetCourseByAngkatan = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/${useBelajarWajibReaderStore().isCPNS ? "cpns-orientation" : "mooc"}/api/getcoursebyangkatan/me/${angkatanId}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.courseMe = response.peserta.body || {};
        });
        this.errorGetCourseByAngkatan = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetCourseByAngkatan = true;
        }
      } finally {
        this.loadingGetCourseByAngkatan = false;
      }
    },
    async getMateriMicro(masterTypeId, size = 10, page = 0) {
      this.loadingGetMateriMicro = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/mooc/api/materi/getmaterimicrobytype/${masterTypeId}/${page}/${size}`,
          "GET",
        );
        useBelajarWajibStore().$patch((state) => {
          state.microList = response || [];
        });
        this.errorGetMateriMicro = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetMateriMicro = true;
        }
      } finally {
        this.loadingGetMateriMicro = false;
      }
    },
    async getUrlBahan(fileName, type) {
      this.loadingGetUrlBahan = true;
      const event = useRequestEvent();
      try {
        const formData = new FormData();
        formData.append("filename", fileName);
        const response = await fetchBelajarWajib(
          event,
          `/${useBelajarWajibReaderStore().isCPNS ? "cpns-orientation" : "mooc"}/api/bahan/downloadbahan`,
          "POST",
          formData,
        );
        useUserStore().$patch({
          snackStatus: "green",
          snackbar: true,
          messageSnack:
            response.message ||
            `Sukses ${type === "download" ? "mengunduh" : "menampilkan"} PDF.`,
        });
        useBelajarWajibStore().$patch((state) => {
          state.pdfBlob = response || [];
        });
        if (type === "download") {
          const url = URL.createObjectURL(response);
          const a = document.createElement("a");
          a.href = url;
          const filename = `${fileName.split("/").pop()}.pdf`;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      } catch (error) {
        useUserStore().$patch({
          snackStatus: "error",
          snackbar: true,
          messageSnack: error?.response?._data?.message || "Terjadi kesalahan.",
        });
      } finally {
        this.loadingGetUrlBahan = false;
      }
    },
    async getToggleFeature() {
      const baseUrl = this.getBelajarWajibBaseUrl();
      try {
        const response = await $fetch.raw(
          `${baseUrl}/public-info/api/maintenance/status`,
          {
            method: "GET",
          },
        );
        useBelajarWajibStore().$patch((state) => {
          state.toggleGeneral = response?._data || {};
          state.toggleList = response?._data?.modules || [];
        });
        localStorage.setItem(
          "toggleList",
          JSON.stringify(response?._data?.modules || []),
        );
        this.toggleFeatureError = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.toggleFeatureError = true;
        }
      }
    },
  },
});
